<template>
  <div class="integral">
    <div class="Tit">我的积分</div>
    <div class="tab">
      <li @click="tabClick(index)" :class="index === tabIndex ? 'choice':'' " v-for="(item,index) in tabs" :key="index">
        {{item}} <span></span>
      </li>
    </div>
    <div class="content">
      <introduce v-if="tabIndex === 0"></introduce>
      <rules v-if="tabIndex === 1"></rules>
      <leaderboard v-if="tabIndex === 2"></leaderboard>
<!--      课程进度排行榜-->
<!--      <raterank v-if="tabIndex === 3"></raterank>-->
    </div>
  </div>
</template>

<script>
  import introduce from '@/components/userInfo/integral/introduce/introduce'
  import rules from '@/components/userInfo/integral/rules/rules'
  import leaderboard from '@/components/userInfo/integral/leaderboard/leaderboard'
  import raterank from '@/components/userInfo/integral/raterank/raterank'

  export default {
    components: {
      introduce,
      rules,
      leaderboard,
      raterank
    },
    data () {
      return {
        tabs: ['我的积分', '积分规则', '积分排行榜'],
        tabIndex: 0,
        info: {}
      }
    },
    created () {
      this.getmypoints()
    },
    methods: {
      tabClick (index) {
        this.tabIndex = index
      },
      getmypoints () {
        this.$http.post('/apipx/Personal/mypoints', {
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .integral {
    .Tit {
      width: 890px;
      height: 69px;
      line-height: 69px;
      font-size: 24px;
      border-bottom: 1px solid #ebebeb;
      font-weight: bold;
    }

    .tab {
      width: 890px;
      height: 130px;
      line-height: 130px;

      li {
        width: 120px;
        height: 130px;
        position: relative;
        float: left;
        cursor: pointer;

        span {
          display: block;
          width: 20px;
          height: 3px;
          background-color: #fff;
          position: absolute;
          left: 13%;
          top: 80px;
        }

        &.choice {
          color: #ff8484;

          span {
            background-color: #ff8484;
          }
        }

        &:nth-child(4n-1) {
          &.choice {
            span {
              left: 20%;
            }
          }
        }

        &:nth-child(4n) {
          &.choice {
            span {
              left: 30%;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/userInfo/integral/integral.vue